// Helper to read a value that may be either a plain string or a per-language dict
// like {en: "...", ro: "...", ...}. Falls back to en, then any first available.

export const loc = (value, lang) => {
  if (value == null) return "";
  if (typeof value === "string") return value;
  if (typeof value === "object" && !Array.isArray(value)) {
    return value[lang] || value.en || Object.values(value)[0] || "";
  }
  return String(value);
};

// For arrays where each item could be string or per-language array
export const locArr = (value, lang) => {
  if (Array.isArray(value)) return value;
  if (value && typeof value === "object") {
    return value[lang] || value.en || Object.values(value)[0] || [];
  }
  return [];
};
